'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';

/**
 * Threshold messaging for products in the tiered spend discount program
 * (MillerKnoll). Renders nothing unless the program is on (a live sale for
 * the group's suppliers - active flag + dates in table_discount_set), the
 * product's supplier qualifies, and a brand_label is configured. Fetches
 * live state so sale start/end takes effect immediately despite static
 * product pages.
 *
 * NOTE: draft copy - wording expected to be edited by the owner.
 */
const TierDiscountProductMessage = t0 => {
  const $ = _c(12);
  const {
    supplier_id
  } = t0;
  const [program, setProgram] = useState(null);
  let t1;
  let t2;
  if ($[0] !== supplier_id) {
    t1 = () => {
      if (!supplier_id) {
        return;
      }
      let cancelled = false;
      fetch("/api/tier-discount").then(_temp).then(data => {
        if (cancelled || !data?.active || !data.tiers?.length) {
          return;
        }
        const group = data.groups?.find(g => g.supplier_ids?.includes(Number(supplier_id)));
        if (!group?.brand_label) {
          return;
        }
        setProgram({
          tiers: data.tiers,
          brand_label: group.brand_label
        });
      }).catch(_temp2);
      return () => {
        cancelled = true;
      };
    };
    t2 = [supplier_id];
    $[0] = supplier_id;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!program) {
    return null;
  }
  const money = _temp3;
  const percent = _temp4;
  let t3;
  if ($[3] !== program.brand_label) {
    t3 = <div className="mb-1 text-ink-medium">On {program.brand_label}:</div>;
    $[3] = program.brand_label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== program.tiers) {
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = tier => <div key={tier.threshold} className="text-red">Spend {money(tier.threshold)} Save {percent(tier.rate)}</div>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    t4 = program.tiers.map(t5);
    $[5] = program.tiers;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-1.5 text-xs text-light">discount applied in cart</div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t4) {
    t6 = <div className="mb-4 text-sm leading-tight text-right">{t3}{t4}{t5}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default TierDiscountProductMessage;
function _temp(res) {
  return res.json();
}
function _temp2() {}
function _temp3(n) {
  return `$${Number(n).toLocaleString("en-US")}`;
}
function _temp4(r) {
  return `${Math.round(r * 100)}%`;
}